import type { Chain } from 'viem'
import { mainnet as mainnetBase, sepolia as sepoliaBase } from 'wagmi/chains'

/**
 * viem の組み込み chain オブジェクトの `rpcUrls.default.http` を env で上書きする。
 *
 * Privy の SmartWalletsProvider (3.3.0) は内部で chain.rpcUrls.default.http[0] を
 * 直接読んで PublicClient を生成する仕様で、外部から transport を注入する口が無い。
 * そのため wagmi の transport 設定だけでは Privy 経路の RPC を差し替えできず、
 * chain オブジェクト自体を上書きする必要がある。
 *
 * 注意: Privy は配列の 0 番目しか使わないため、fallback URL が効くのは wagmi 経由
 * の呼び出し (残高取得等) に限られる。Privy 経路は常に primary のみ。
 */
export function withCustomRpc(base: Chain, primary?: string, fallback?: string): Chain {
  const urls = [primary, fallback].filter(
    (url): url is string => typeof url === 'string' && url.length > 0
  )
  if (urls.length === 0) return base
  const [first, ...rest] = urls
  return {
    ...base,
    rpcUrls: {
      ...base.rpcUrls,
      default: { http: [first, ...rest] as const },
    },
  }
}

const envChain = (import.meta.env.VITE_CHAIN ?? '').toLowerCase()

export const chain =
  envChain === 'mainnet'
    ? withCustomRpc(
        mainnetBase,
        import.meta.env.VITE_MAINNET_RPC_URL,
        import.meta.env.VITE_MAINNET_RPC_URL_FALLBACK
      )
    : withCustomRpc(
        sepoliaBase,
        import.meta.env.VITE_SEPOLIA_RPC_URL,
        import.meta.env.VITE_SEPOLIA_RPC_URL_FALLBACK
      )
